export const INVALID_REQUEST_HANDLER = 'Invalid request handler';
export const validateRequestHandler = (requestHandler) => {
    if (!requestHandler || typeof requestHandler !== 'object') {
        throw new Error(INVALID_REQUEST_HANDLER);
    }
    if (typeof requestHandler.makeRequest !== 'function') {
        throw new Error(INVALID_REQUEST_HANDLER);
    }
};
export const __platforms = ['__universal__'];
//# sourceMappingURL=request_handler_validator.js.map